import { render, staticRenderFns } from "./BalanceCard.vue?vue&type=template&id=3df64ab1"
import script from "./BalanceCard.vue?vue&type=script&lang=js"
export * from "./BalanceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports